import { Stack, Typography } from "@mui/material";
import { IShareModalIcon } from "../../../../interfaces/globalComponents/shareModal/IShareModalIcon";
export const ShareModalIcon = ({
  Icon,
  name,
  bgColor,
  textColor,
}: IShareModalIcon) => {
  return (
    <div className="flex flex-col items-center space-y-[8px]">
      <Stack
        sx={{
          backgroundColor: bgColor,
        }}
        className="xs:w-[40px] xs:h-[40px]  ms:w-[64px] ms:h-[64px] 
        rounded-full flex items-center justify-center  opacity-100 lg:opacity-80 lg:hover:opacity-100 transition-all"
      >
        <Icon
          style={{
            color: textColor,
            width: "28px",
            height: "28px",
          }}
        />
      </Stack>
      <Typography
        className="xs:text-[10px] ms:text-[12px]"
        sx={{
          color: textColor,
        }}
      >
        {name}
      </Typography>
    </div>
  );
};
